export * from "./AlertsPolling";

export { useAlertsPolling } from "./hooks";
